import React, {useState} from 'react';
import RoomImagesSlider from "../components/RoomImagesSlider";
import FormSelection from "../components/modals/FormSelection";
import {Button} from "react-bootstrap"; // Убедись, что путь правильный

// Только этот массив обновлен на основе данных из "Джиналь" и вашего порядка
const roomTypes = [
    {
        // 1. Двухместный номер «твин/дабл» «Улучшенный» - БЕЗ ИЗМЕНЕНИЙ
        id: 'djinal-twin-double-improved',
        category: 'НОМЕРА САНАТОРИЯ',
        title: 'Двухместный номер твин/дабл Улучшенный',
        description: 'Уютный номер площадью 18 м². Номер оснащен раздельными или двуспальной кроватями. Номер оборудован всем необходимым для комфортного проживания.',
        features: [
            'Площадь: 18 м²',
            'Кровать: 2 односпальные или 1 двуспальная',
            'Прикроватные тумбы',
            'Рабочий стол, стулья',
            'Санузел с душевой кабиной',
            'Фен',
            'Телевизор',
            'Мини-холодильник',
            'Кондиционер',
            'Набор посуды, чайник',
            'Wi-Fi',
        ],
        images: [
            '/Assets/Rooms/1/1.jpg',
            '/Assets/Rooms/1/2.jpg',
            '/Assets/Rooms/1/3.jpg',
            '/Assets/Rooms/1/4.jpg',
            '/Assets/Rooms/1/5.jpg',
            '/Assets/Rooms/1/6.jpg',
        ],
        price: 'от 8900 руб/сутки',
        link: 'https://www.djinal.ru/rooms/dvuhmestnyj-nomer-tvindabl-ulucsennyj/'
    },
    {
        // 2. Двухместный номер «дабл» «Комфорт» - БЕЗ ИЗМЕНЕНИЙ
        id: 'djinal-double-comfort',
        category: 'НОМЕРА САНАТОРИЯ',
        title: 'Двухместный номер дабл Комфорт',
        description: 'Комфортабельный однокомнатный номер площадью 23 м², оснащенный всем необходимым для приятного пребывания двух гостей. Улучшенная комплектация для вашего удобства.',
        features: [
            'Площадь: 23 м²',
            'Кровать: 1 двуспальная',
            'Шкаф для одежды',
            'Прикроватные тумбы',
            'Телевизор',
            'Холодильник',
            'Санузел с душем',
            'Wi-Fi',
            'Улучшенная комплектация',
        ],
        images: [
            '/Assets/Rooms/2/1.jpg',
            '/Assets/Rooms/2/2.jpg',
            '/Assets/Rooms/2/3.jpg',
            '/Assets/Rooms/2/4.jpg',
            '/Assets/Rooms/2/5.jpg',
            '/Assets/Rooms/2/6.jpg',
        ],
        price: 'от 9800 руб/сутки',
        link: 'https://www.djinal.ru/rooms/double/'
    },
    {
        // 3. Двухместный номер «ДАБЛ» "Стандарт" - БЕЗ ИЗМЕНЕНИЙ
        id: 'djinal-double-standart',
        category: 'НОМЕРА САНАТОРИЯ',
        title: 'Двухместный номер ДАБЛ Стандарт',
        description: 'Стандартный однокомнатный номер площадью 18 м², предназначенный для двух гостей.',
        features: [
            'Площадь: 18 м²', // Исправлено на 18 м² согласно поиску
            'Кровать: 1 двуспальная',
            'Шкаф для одежды',
            'Прикроватные тумбы',
            'Телевизор',
            'Хололодильник',
            'Санузел с душем',
            'Wi-Fi',
        ],
        images: [
            '/Assets/Rooms/3/1.jpg',
            '/Assets/Rooms/3/2.jpg',
        ],
        price: 'от 7700 руб/сутки',
        link: 'https://www.djinal.ru/rooms/double/'
    },
    {
        // 4. Двухместный двухкомнатный номер «дабл» «Премиум» - ВАРИАНТ 1
        // Предполагаем, что это один из 7 вариантов. Продублируйте для остальных 6.
        id: 'djinal-premium-double-suite-variant1',
        category: 'НОМЕРА САНАТОРИЯ',
        title: 'Двухместный двухкомнатный номер дабл Премиум (Дизайн 1)',
        description: 'Просторный двухкомнатный номер категории "Премиум" площадью 35 м² с гостиной и спальней. Представлен в классическом стиле. Оснащен мягкой мебелью, современной техникой и двумя санузлами.',
        features: [
            'Площадь: 35 м²',
            'Двухкомнатный (гостиная и спальня)',
            'Кровать: 1 двуспальная King-size',
            'Телевизор',
            'Мини-бар',
            'Кондиционер',
            'Фен, тапочки, халаты',
            'Wi-Fi',
        ],
        images: [
            '/Assets/Rooms/4/1.jpg', // Замените на реальные фото для Дизайна 1
            '/Assets/Rooms/4/2.jpg',
            '/Assets/Rooms/4/3.jpg',
            '/Assets/Rooms/4/4.jpg',
            '/Assets/Rooms/4/5.jpg',
            '/Assets/Rooms/4/6.jpg',
        ],
        price: 'от 11600 руб/сутки',
        link: 'https://www.djinal.ru/rooms/lux/' // Или более точная ссылка на конкретный дизайн, если есть
    },
    {
        // 4. Двухместный двухкомнатный номер «дабл» «Премиум» - ВАРИАНТ 2
        id: 'djinal-premium-double-suite-variant2',
        category: 'НОМЕРА САНАТОРИЯ',
        title: 'Двухместный двухкомнатный номер дабл Премиум (Дизайн 2)',
        description: 'Просторный двухкомнатный номер категории "Премиум" площадью 35 м² с гостиной и спальней. Представлен в современном стиле. Оснащен мягкой мебелью, современной техникой и двумя санузлами.',
        features: [
            'Площадь: 35 м²',
            'Двухкомнатный (гостиная и спальня)',
            'Кровать: 1 двуспальная King-size',
            'Мягкая мебель (диван, кресла)',
            'Телевизор',
            'Мини-бар',
            'Кондиционер',
            'Фен, тапочки, халаты',
        ],
        images: [
            '/Assets/Rooms/5/1.jpg', // Замените на реальные фото для Дизайна 2
            '/Assets/Rooms/5/2.jpg',
            '/Assets/Rooms/5/3.jpg',
            '/Assets/Rooms/5/4.jpg',
            '/Assets/Rooms/5/5.jpg',
            '/Assets/Rooms/5/6.jpg',
        ],
        price: 'от 11600 руб/сутки',
        link: 'https://www.djinal.ru/rooms/lux/'
    },
    {
        // 4. Двухместный двухкомнатный номер «дабл» «Премиум» - ВАРИАНТ 3
        id: 'djinal-premium-double-suite-variant3',
        category: 'НОМЕРА САНАТОРИЯ',
        title: 'Двухместный двухкомнатный номер дабл Премиум (Дизайн 3)',
        description: 'Просторный двухкомнатный номер категории "Премиум" площадью 35 м² с гостиной и спальней. Представлен в светлых тонах. Оснащен мягкой мебелью, современной техникой и двумя санузлами.',
        features: [
            'Площадь: 35 м²',
            'Двухкомнатный (гостиная и спальня)',
            'Кровать: 1 двуспальная King-size',
            'Мягкая мебель (диван, кресла)',
            'Телевизор',
            'Мини-бар',
            'Кондиционер',
            'Фен, тапочки, халаты',
        ],
        images: [
            '/Assets/Rooms/6/1.jpg',
            '/Assets/Rooms/6/2.jpg',
            '/Assets/Rooms/6/3.jpg',
            '/Assets/Rooms/6/4.jpg',
            '/Assets/Rooms/6/5.jpg',
        ],
        price: 'от 11600 руб/сутки',
        link: 'https://www.djinal.ru/rooms/lux/'
    },
    {
        // 5. Двухместный номер «ТВИН» (без балкона)
        id: 'djinal-room-twin-no-balcony',
        category: 'НОМЕРА САНАТОРИЯ',
        title: 'Двухместный номер ТВИН (без балкона)',
        description: 'Стандартный однокомнатный номер площадью 18 м² без балкона. В номере есть кондиционер, телевизор, холодильник, телефон и набор посуды. Санузел с душевой кабиной и феном.',
        features: [
            'Площадь: 18 м²',
            'Кровать: 2 односпальные',
            'Рабочий стол',
            'Санузел с душем',
            'Холодильник',
            'Кондиционер',
            'Фен',
        ],
        images: [
            '/Assets/Rooms/7/1.jpg', // Замените на реальные пути
            '/Assets/Rooms/7/2.jpg',
            '/Assets/Rooms/7/3.jpg',
        ],
        price: 'от 6900 руб/сутки',
        link: 'https://www.djinal.ru/rooms/roomtwin/'
    },
    {
        // 6. Двухместный номер «ТВИН» "Стандарт"
        id: 'djinal-room-twin-standart',
        category: 'НОМЕРА САНАТОРИЯ',
        title: 'Двухместный номер ТВИН Стандарт',
        description: 'Стандартный двухместный номер площадью 18 м² с двумя раздельными кроватями.',
        features: [
            'Площадь: 18 м²',
            'Кровать: 2 односпальные',
            'Кондиционер',
            'Холодильник',
            'Санузел с душем',
            'Набор полотенец',
            'Электрочайник',
        ],
        images: [
            '/Assets/Rooms/8/1.jpg', // Замените на реальные пути
            '/Assets/Rooms/8/2.jpg',
        ],
        price: 'от 7700 руб/сутки',
        link: 'https://www.djinal.ru/rooms/roomtwin2/'
    },
    {
        // 7. Одноместный номер "Стандарт"
        id: 'djinal-one-standart',
        category: 'НОМЕРА САНАТОРИЯ',
        title: 'Одноместный номер Стандарт',
        description: 'Компактный и уютный номер площадью 16 м² для индивидуальных путешественников. Оборудован всем необходимым для комфортного проживания одного человека, включая односпальную кровать, рабочее пространство, телевизор, холодильник. Включает санузел и балкон.',
        features: [
            'Площадь: 16 м²',
            'Балкон',
            'Кровать: 1 односпальная',
            'Рабочий стол',
            'Санузел с душем',
            'Телевизор'
        ],
        images: [
            '/Assets/Rooms/9/1.jpg', // Замените на реальные пути
            '/Assets/Rooms/9/2.jpg',
            '/Assets/Rooms/9/3.jpg',
            '/Assets/Rooms/9/4.jpg',
            '/Assets/Rooms/9/5.jpg',
        ],
        price: 'от 10600 руб/сутки',
        link: 'https://www.djinal.ru/rooms/one/'
    },
    {
        // 8. Апартаменты "Модерн"
        id: 'djinal-apartment-modern',
        category: 'НОМЕРА САНАТОРИЯ',
        title: 'Апартаменты "Модерн"',
        description: 'Элегантные и просторные апартаменты площадью 70 м², предлагающие максимум комфорта и уюта в стиле "Прованс".',
        features: [
            'Площадь: 70 м²',
            '3 балкона',
            'Несколько комнат (спальня, гостиная, кухня)',
            'Кровать: 1 двуспальная King-size',
            'Полностью оборудованная кухня',
            'Обеденная зона',
            'Современная бытовая техника',
            'Кондиционер',
            'Сейф'
        ],
        images: [
            '/Assets/Rooms/10/1.jpg', // Замените на реальные пути
            '/Assets/Rooms/10/2.jpg',
            '/Assets/Rooms/10/3.jpg',
            '/Assets/Rooms/10/4.jpg',
            '/Assets/Rooms/10/5.jpg',
        ],
        price: 'от 14800 руб/сутки',
        link: 'https://www.djinal.ru/rooms/apartment/'
    },
    {
        // 9. Апартаменты "Прованс"
        id: 'djinal-apartment-provence',
        category: 'НОМЕРА САНАТОРИЯ',
        title: 'Апартаменты "Прованс"',
        description: 'Элегантные и просторные апартаменты площадью 70 м², предлагающие максимум комфорта и уюта в стиле "Прованс".',
        features: [
            'Площадь: 70 м²',
            '3 балкона',
            'Несколько комнат (спальня, гостиная, кухня)',
            'Кровать: 1 двуспальная King-size',
            'Полностью оборудованная кухня',
            'Обеденная зона',
            'Современная бытовая техника',
            'Кондиционер',
            'Сейф'
        ],
        images: [
            '/Assets/Rooms/11/1.jpg', // Замените на реальные пути
            '/Assets/Rooms/11/2.jpg',
            '/Assets/Rooms/11/3.jpg',
            '/Assets/Rooms/11/4.jpg',
            '/Assets/Rooms/11/5.jpg',
            '/Assets/Rooms/11/6.jpg',
        ],
        price: 'от 14800 руб/сутки',
        link: 'https://www.djinal.ru/rooms/apartment/'
    },
];

// Группируем номера по категориям
const groupedRoomTypes = Object.entries(roomTypes.reduce((acc, room) => {
    if (!acc[room.category]) {
        acc[room.category] = [];
    }
    acc[room.category].push(room);
    return acc;
}, {}));


const RoomsPage = () => {

    const [formSelectionVisible, setFormSelectionVisible] = useState(false);

    return (
        <div className="rooms-page-container">
            <header className="page-header">
                <h1>Номера Санатория "Джинал"</h1>
            </header>

            <div className="sections-wrapper">

                {groupedRoomTypes.map(([category, rooms], categoryIndex) => (
                    <section className="room-category-section" key={categoryIndex}>
                        <h2 className="room-category-title">{category}</h2>

                        <div className="room-list-alternating">
                            {rooms.map((room, roomIndex) => (
                                <div className={`room-card-alternating ${roomIndex % 2 !== 0 ? 'reverse' : ''}`} key={room.id}>

                                    <div className="room-image-slider-container-alt">
                                        {room.images && room.images.length > 0 ? (
                                            <RoomImagesSlider images={room.images} />
                                        ) : (
                                            <div className="no-images-placeholder-alt">Нет фото</div>
                                        )}
                                    </div>

                                    <div
                                        className="room-info-block-alt">
                                        <h3 className="room-title-alt">{room.title}</h3>
                                        <p className="room-description-alt">{room.description}</p>

                                        {room.features && room.features.length > 0 && (
                                            <div
                                                className="room-features-block-alt">
                                                <h4 className="features-title-alt">Особенности
                                                    номера:</h4>
                                                <ul className="room-features-list-alt">
                                                    {room.features.map((feature, featureIndex) => (
                                                        <li key={featureIndex}>{feature}</li>
                                                    ))}
                                                </ul>
                                            </div>
                                        )}
                                        {room.price &&
                                            <div className="room-price-alt">
                                                <Button
                                                    variant="success"
                                                    className="room-details-button"
                                                    onClick={() => setFormSelectionVisible(true)}
                                                    size="sm"
                                                >
                                                    ПОДРОБНЕЕ
                                                </Button>
                                                {room.price}
                                            </div>
                                        }
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>
                ))}
            </div>
            <FormSelection show={formSelectionVisible} onHide={() => setFormSelectionVisible(false)}/>
        </div>
    );
};

export default RoomsPage;